import TemplatesList from 'components/@home/drawers/HrBotDrawer/TemplatesList';
import React from 'react';

const HrBotEditTemplates = () => <TemplatesList />;

export default HrBotEditTemplates;
